'use client'// components/Hero.js
import { useEffect, useState } from "react";

export default function Hero() {
  const [visible, setVisible] = useState(false);
  useEffect(() => {
    const t = setTimeout(() => setVisible(true), 120);
    return () => clearTimeout(t);
  }, []);

  return (
    <>
    <section className="loanpulse-wavy relative overflow-visible py-16">

 <div className="container mx-auto px-4">
        {/* 12-column grid: text uses 7 cols, image uses 5 cols */}
        <div className="grid items-center gap-8 md:grid-cols-12">
          {/* LEFT: text (span 7 on md+) */}
          <div className={`md:col-span-7 ${visible ? "fade-up visible" : "fade-up"}`}>
            <p className="text-sm lp-muted font-medium mb-3">For DSAs • Agents • Banks</p>

            <h1 className="text-4xl md:text-5xl font-extrabold leading-tight mb-5 drop-shadow-lg">
              <>
                <span className="block text-2xl md:text-3xl">Loan journeys don’t have to be confusing.</span>
                <span className="block text-2xl md:text-3xl">Share checklists instantly.</span>
              </>
              
            </h1>

            <p className="mt-5 max-w-prose text-lg lp-muted">
              Built for DSAs, agents, and banks who want fewer follow-ups, clearer communication, and faster loan approvals — all from one simple, powerful tool.</p>

            <div className="mt-7 flex flex-wrap gap-3 items-center">
              <img src="/PreRegisterOnGooglePlay_Badge_Web_color_english.png" alt="" className="w-44"/>
              
            </div>

            <ul className="flex flex-wrap gap-x-5 mt-6 text-sm">
              <li className="text-white">Pre-filled Checklists templates</li>
              <li className="text-white">One-tap WhatsApp sharing</li>
              <li className="text-white">Track every stage effortlessly</li>
            </ul>
          </div>

          {/* RIGHT: image (span 5 on md+) - ensure right alignment */}
          <div className="md:col-span-5 flex justify-center md:justify-end">
            <div className="phone-card w-full max-w-[360px]">
              {/* Use svg or PNG; constrain size so it never overflows */}
              <img
                src="/screens/hero-phone2.png"
                alt="LoanPulse screenshot"
                className="w-full h-auto block rounded-lg"
                style={{ display: "block", maxWidth: "360px" }}
              />
            </div>
          </div>
        </div>
      </div>
    </section>
    
{/*
    <section className="loanpulse-wavy py-24">
      <div className="lp-content max-w-7xl mx-auto px-6 grid md:grid-cols-12 gap-10 items-center">

        {/* LEFT 
        <div className="md:col-span-7">
          <p className="text-sm lp-muted font-medium mb-3">For DSAs • Agents • Banks</p>

          <h1 className="text-4xl md:text-5xl font-extrabold leading-tight mb-5 drop-shadow-lg">
            Share checklists. <br />Close loans faster.
          </h1>

          <p className="text-lg lp-muted max-w-xl mb-6">
            One-tap WhatsApp checklist sharing, role-based workflows and real-time
            loan tracking — built for DSAs, agents and bank teams.
          </p>

          <div className="flex flex-wrap gap-4">
            <a href="#contact" className="lp-btn-primary">Request Demo</a>
            <a href="/download" className="lp-btn-outline">Download APK</a>
          </div>

          <ul className="flex flex-wrap gap-x-5 mt-6 text-sm lp-muted">
            <li>• Pre-filled WhatsApp templates</li>
            <li>• Role-based workflows</li>
            <li>• Lightweight for slow networks</li>
          </ul>
        </div>

        {/* RIGHT PHONE MOCKUP 
        <div className="md:col-span-5 flex justify-end">
          <div className="bg-white/10 backdrop-blur-md rounded-2xl p-4 shadow-2xl border border-white/20">
            <img
              src="/screens/hero-phone.jpg"
              alt="LoanPulse app preview"
              className="rounded-xl w-[340px]"
            />
          </div>
        </div>
      </div>
    </section>
*/}

    </>
  );
}



